import {useIsElementDark} from '~/utils/useIsElementDark'

export const ProPlanIcon = ({className}: {className?: string}) => {
  const {ref, isDarkMode} = useIsElementDark()

  if (isDarkMode) {
    return (
      <svg
        ref={ref}
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <g id="icons8-working-with-a-macbook 2">
          <g id="Group">
            <path id="Vector" d="M14.25 31.5H33.75L41.25 46.5H6.75L14.25 31.5Z" fill="#18181A" />
          </g>
          <g id="Group_2">
            <path
              id="Vector_2"
              d="M8.43724 43.9497C8.24974 43.9497 8.06224 43.9122 7.91224 43.7997C7.34974 43.4997 7.16224 42.8247 7.46224 42.2622L8.58724 40.1622C8.88724 39.5997 9.56224 39.4122 10.1247 39.7122C10.6872 40.0122 10.8747 40.6872 10.5747 41.2497L9.44974 43.3497C9.22474 43.7247 8.84974 43.9497 8.43724 43.9497Z"
              fill="white"
            />
          </g>
          <g id="Group_3">
            <path
              id="Vector_3"
              d="M11.4375 46.5H3.9375C3.9375 44.4375 5.625 42.75 7.6875 42.75C9.75 42.75 11.4375 44.4375 11.4375 46.5Z"
              fill="#18181A"
            />
          </g>
          <g id="Group_4">
            <path
              id="Vector_4"
              d="M3.9375 47.625C3.3 47.625 2.8125 47.1375 2.8125 46.5C2.8125 43.8 4.9875 41.625 7.6875 41.625C8.025 41.625 8.3625 41.6625 8.6625 41.7375C9.2625 41.85 9.675 42.45 9.525 43.05C9.4125 43.65 8.8125 44.0625 8.2125 43.9125C8.025 43.875 7.875 43.875 7.6875 43.875C6.225 43.875 5.0625 45.0375 5.0625 46.5C5.0625 47.1375 4.575 47.625 3.9375 47.625Z"
              fill="white"
            />
          </g>
          <g id="Group_5">
            <g id="Group_6">
              <path
                id="Vector_5"
                d="M31.6498 32.625H13.4248C12.7873 32.625 12.2998 32.1375 12.2998 31.5C12.2998 30.8625 12.7873 30.375 13.4248 30.375H31.6498C32.2873 30.375 32.7748 30.8625 32.7748 31.5C32.7748 32.1375 32.2498 32.625 31.6498 32.625Z"
                fill="white"
              />
            </g>
          </g>
          <g id="Group_7">
            <g id="Group_8">
              <g id="Group_9">
                <g id="Group_10">
                  <path
                    id="Vector_6"
                    d="M24 27.375C28.1421 27.375 31.5 24.0171 31.5 19.875C31.5 15.7329 28.1421 12.375 24 12.375C19.8579 12.375 16.5 15.7329 16.5 19.875C16.5 24.0171 19.8579 27.375 24 27.375Z"
                    fill="#18181A"
                  />
                </g>
              </g>
              <g id="Group_11">
                <g id="Group_12">
                  <path
                    id="Vector_7"
                    d="M24 28.5C19.2375 28.5 15.375 24.6375 15.375 19.875C15.375 15.1125 19.2375 11.25 24 11.25C28.7625 11.25 32.625 15.1125 32.625 19.875C32.625 24.6375 28.7625 28.5 24 28.5ZM24 13.5C20.475 13.5 17.625 16.35 17.625 19.875C17.625 23.4 20.475 26.25 24 26.25C27.525 26.25 30.375 23.4 30.375 19.875C30.375 16.35 27.525 13.5 24 13.5Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
            <g id="Group_13">
              <g id="Group_14">
                <g id="Group_15">
                  <path
                    id="Vector_8"
                    d="M13.8752 46.5L11.4752 32.8125C11.3627 32.1375 11.8877 31.5 12.6002 31.5H35.4377C36.1502 31.5 36.6752 32.1375 36.5627 32.8125L34.1252 46.5H13.8752Z"
                    fill="#6610F2"
                  />
                </g>
              </g>
              <g id="Group_16">
                <g id="Group_17">
                  <path
                    id="Vector_9"
                    d="M24 40.875C25.0355 40.875 25.875 40.0355 25.875 39C25.875 37.9645 25.0355 37.125 24 37.125C22.9645 37.125 22.125 37.9645 22.125 39C22.125 40.0355 22.9645 40.875 24 40.875Z"
                    fill="#18181A"
                  />
                </g>
              </g>
              <g id="Group_18">
                <g id="Group_19">
                  <path
                    id="Vector_10"
                    d="M13.8751 47.625C13.3501 47.625 12.8626 47.25 12.7501 46.6875L10.3876 33C10.2751 32.325 10.4626 31.6875 10.8751 31.1625C11.2876 30.6375 11.9251 30.375 12.6001 30.375H35.4376C36.1126 30.375 36.7501 30.675 37.1626 31.1625C37.5751 31.6875 37.7626 32.325 37.6501 33L35.2501 46.6875C35.1376 47.2875 34.5751 47.7 33.9376 47.5875C33.3376 47.475 32.9251 46.9125 33.0376 46.275L35.4001 32.625H12.6001L15.0001 46.3125C15.1126 46.9125 14.7001 47.5125 14.1001 47.625C13.9876 47.625 13.9501 47.625 13.8751 47.625Z"
                    fill="white"
                  />
                </g>
              </g>
              <g id="Group_20">
                <g id="Group_21">
                  <path
                    id="Vector_11"
                    d="M46.5 47.625H10.3125C9.675 47.625 9.1875 47.1375 9.1875 46.5C9.1875 45.8625 9.675 45.375 10.3125 45.375H46.5C47.1375 45.375 47.625 45.8625 47.625 46.5C47.625 47.1375 47.1375 47.625 46.5 47.625Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
          </g>
          <path
            id="Vector_12"
            d="M41.2504 47.6248C40.8379 47.6248 40.4254 47.3998 40.2379 46.9873L37.6129 41.6998C37.3504 41.1373 37.5754 40.4623 38.1004 40.1998C38.6629 39.9373 39.3379 40.1623 39.6004 40.6873L42.2254 45.9748C42.4879 46.5373 42.2629 47.2123 41.7379 47.4748C41.5879 47.5873 41.4379 47.6248 41.2504 47.6248Z"
            fill="white"
          />
        </g>
      </svg>
    )
  }

  return (
    <svg
      ref={ref}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="icons8-working-with-a-macbook 1">
        <g id="Group">
          <path id="Vector" d="M14.25 31.5H33.75L41.25 46.5H6.75L14.25 31.5Z" fill="white" />
        </g>
        <g id="Group_2">
          <path
            id="Vector_2"
            d="M8.43724 43.9497C8.24974 43.9497 8.06224 43.9122 7.91224 43.7997C7.34974 43.4997 7.16224 42.8247 7.46224 42.2622L8.58724 40.1622C8.88724 39.5997 9.56224 39.4122 10.1247 39.7122C10.6872 40.0122 10.8747 40.6872 10.5747 41.2497L9.44974 43.3497C9.22474 43.7247 8.84974 43.9497 8.43724 43.9497Z"
            fill="#2B2D2E"
          />
        </g>
        <g id="Group_3">
          <path
            id="Vector_3"
            d="M11.4375 46.5H3.9375C3.9375 44.4375 5.625 42.75 7.6875 42.75C9.75 42.75 11.4375 44.4375 11.4375 46.5Z"
            fill="white"
          />
        </g>
        <g id="Group_4">
          <path
            id="Vector_4"
            d="M3.9375 47.625C3.3 47.625 2.8125 47.1375 2.8125 46.5C2.8125 43.8 4.9875 41.625 7.6875 41.625C8.025 41.625 8.3625 41.6625 8.6625 41.7375C9.2625 41.85 9.675 42.45 9.525 43.05C9.4125 43.65 8.8125 44.0625 8.2125 43.9125C8.025 43.875 7.875 43.875 7.6875 43.875C6.225 43.875 5.0625 45.0375 5.0625 46.5C5.0625 47.1375 4.575 47.625 3.9375 47.625Z"
            fill="#2B2D2E"
          />
        </g>
        <g id="Group_5">
          <g id="Group_6">
            <path
              id="Vector_5"
              d="M31.6498 32.625H13.4248C12.7873 32.625 12.2998 32.1375 12.2998 31.5C12.2998 30.8625 12.7873 30.375 13.4248 30.375H31.6498C32.2873 30.375 32.7748 30.8625 32.7748 31.5C32.7748 32.1375 32.2498 32.625 31.6498 32.625Z"
              fill="#2B2D2E"
            />
          </g>
        </g>
        <g id="Group_7">
          <g id="Group_8">
            <g id="Group_9">
              <g id="Group_10">
                <path
                  id="Vector_6"
                  d="M24 27.375C28.1421 27.375 31.5 24.0171 31.5 19.875C31.5 15.7329 28.1421 12.375 24 12.375C19.8579 12.375 16.5 15.7329 16.5 19.875C16.5 24.0171 19.8579 27.375 24 27.375Z"
                  fill="white"
                />
              </g>
            </g>
            <g id="Group_11">
              <g id="Group_12">
                <path
                  id="Vector_7"
                  d="M24 28.5C19.2375 28.5 15.375 24.6375 15.375 19.875C15.375 15.1125 19.2375 11.25 24 11.25C28.7625 11.25 32.625 15.1125 32.625 19.875C32.625 24.6375 28.7625 28.5 24 28.5ZM24 13.5C20.475 13.5 17.625 16.35 17.625 19.875C17.625 23.4 20.475 26.25 24 26.25C27.525 26.25 30.375 23.4 30.375 19.875C30.375 16.35 27.525 13.5 24 13.5Z"
                  fill="#2B2D2E"
                />
              </g>
            </g>
          </g>
          <g id="Group_13">
            <g id="Group_14">
              <g id="Group_15">
                <path
                  id="Vector_8"
                  d="M13.8752 46.5L11.4752 32.8125C11.3627 32.1375 11.8877 31.5 12.6002 31.5H35.4377C36.1502 31.5 36.6752 32.1375 36.5627 32.8125L34.1252 46.5H13.8752Z"
                  fill="#BDB2FF"
                />
              </g>
            </g>
            <g id="Group_16">
              <g id="Group_17">
                <path
                  id="Vector_9"
                  d="M24 40.875C25.0355 40.875 25.875 40.0355 25.875 39C25.875 37.9645 25.0355 37.125 24 37.125C22.9645 37.125 22.125 37.9645 22.125 39C22.125 40.0355 22.9645 40.875 24 40.875Z"
                  fill="white"
                />
              </g>
            </g>
            <g id="Group_18">
              <g id="Group_19">
                <path
                  id="Vector_10"
                  d="M13.8751 47.625C13.3501 47.625 12.8626 47.25 12.7501 46.6875L10.3876 33C10.2751 32.325 10.4626 31.6875 10.8751 31.1625C11.2876 30.6375 11.9251 30.375 12.6001 30.375H35.4376C36.1126 30.375 36.7501 30.675 37.1626 31.1625C37.5751 31.6875 37.7626 32.325 37.6501 33L35.2501 46.6875C35.1376 47.2875 34.5751 47.7 33.9376 47.5875C33.3376 47.475 32.9251 46.9125 33.0376 46.275L35.4001 32.625H12.6001L15.0001 46.3125C15.1126 46.9125 14.7001 47.5125 14.1001 47.625C13.9876 47.625 13.9501 47.625 13.8751 47.625Z"
                  fill="#2B2D2E"
                />
              </g>
            </g>
            <g id="Group_20">
              <g id="Group_21">
                <path
                  id="Vector_11"
                  d="M46.5 47.625H10.3125C9.675 47.625 9.1875 47.1375 9.1875 46.5C9.1875 45.8625 9.675 45.375 10.3125 45.375H46.5C47.1375 45.375 47.625 45.8625 47.625 46.5C47.625 47.1375 47.1375 47.625 46.5 47.625Z"
                  fill="#2B2D2E"
                />
              </g>
            </g>
          </g>
        </g>
        <path
          id="Vector_12"
          d="M41.2504 47.6248C40.8379 47.6248 40.4254 47.3998 40.2379 46.9873L37.6129 41.6998C37.3504 41.1373 37.5754 40.4623 38.1004 40.1998C38.6629 39.9373 39.3379 40.1623 39.6004 40.6873L42.2254 45.9748C42.4879 46.5373 42.2629 47.2123 41.7379 47.4748C41.5879 47.5873 41.4379 47.6248 41.2504 47.6248Z"
          fill="#2B2D2E"
        />
      </g>
    </svg>
  )
}
